import React from 'react';
import Button, { ILink } from 'tbk-components/src/components/Button';

/**
 * Pretty PDF
 * @block
 * @requiresHooks
 * @icon pdf
 */
const PrettyPDF: React.FC<ILink> = (props) => (
	<Button {...props} className="pretty-pdf" />
);

export default PrettyPDF;
